export default __webpack_public_path__ + "static/media/myself.3fd86f44.png";